<template>

    <div class="instagram-card-wrapper">
        <div class="instagram-card sizing-container">
            <img :src="sizingImg" alt="" class="f1 sizing-placeholder">
            <div class="sizing-img" :style="{backgroundImage: `url(${img})`}"></div>
            <div class="px-3 c-white text-center">
                <div class="instagram-mask"></div>
                <div class="instagram-content">
                    <p class="pb-10 fs-16">The Willows Band grabbing a couple of cheeky pre-gig pints</p>
                    <div class="p-2 absolute-bottom-left full-width text-center">
                        <div class="mb-1 d-flex align-items-center justify-content-center">
                            <span class="icon --small --clock"></span><span class="px-05 fw-light lh-15">8 Nov</span>
                        </div>
                        <div class="d-flex align-items-center justify-content-center">
                            <span class="icon --small --heart"></span><span class="px-05 fw-light lh-15">29</span><span class="icon --small --bubble"></span><span class="px-05 fw-light lh-15">0</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import {sample} from 'lodash';

    export default {
        name: 'InstagramCard',

        data() {
            return {
                images: [
                    'instagram-1.png',
                    'instagram-2.png',
                    'instagram-3.png',
                    'instagram-4.png',
                ]
            }
        },

        computed: {
            base() {
                return window.imgUrl;
            },
            sizingImg() {
                return this.base + '/svg/1-1-sizing.svg';
            },
            img() {
                return this.base + '/stock/' + _.sample(this.images);
            }
        }
    }

</script>
